import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
export default styled(Card)(({ theme, ownerState }) => {
  const { palette } = theme;
  const { color } = ownerState;
  return {
   padding:'16px',
    boxShadow: "1px 2px 5px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "10.5px",
    minHeight:'100%'
  };
});
